import React from 'react';
import PropTypes from 'prop-types';
var MobileMenuItem = function MobileMenuItem(_ref) {
  var link = _ref.link,
    onItemSelected = _ref.onItemSelected,
    LinkTemplate = _ref.LinkTemplate;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(LinkTemplate, {
    onClick: onItemSelected,
    className: "menu__mobile-item link",
    url: link.url
  }, /*#__PURE__*/React.createElement("span", {
    className: "link__content"
  }, link.text)));
};
MobileMenuItem.propTypes = {
  link: PropTypes.shape({
    text: PropTypes.string,
    url: PropTypes.string
  }),
  onItemSelected: PropTypes.func,
  LinkTemplate: PropTypes.func
};
export default MobileMenuItem;